/**
 * Converts a string path to a value that is existing in a json object.
 *
 * @param {Object} jsonData Json data to use for searching the value.
 * @param {Object} path the path to use to find the value.
 * @returns {valueOfThePath|null}
 */
export const jsonPathToValue = (jsonData: any, path: string) => {
  if (!(jsonData instanceof Object) || typeof path === 'undefined') {
    throw new Error(`Not valid argument:jsonData:${jsonData}, path:${path}`);
  }

  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  const pathArray = path.split('.');
  for (let i = 0, n = pathArray.length; i < n; ++i) {
    const key = pathArray[i];
    if (key in jsonData) {
      if (jsonData[key] !== null) {
        jsonData = jsonData[key];
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  return jsonData;
};

export default { jsonPathToValue };
